import { render, staticRenderFns } from "./ExportsDetails.vue?vue&type=template&id=5801d74a"
import script from "./ExportsDetails.vue?vue&type=script&lang=js"
export * from "./ExportsDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports